import { render, staticRenderFns } from "./SCodePreview.vue?vue&type=template&id=b0d950d0&"
import script from "./SCodePreview.vue?vue&type=script&lang=js&"
export * from "./SCodePreview.vue?vue&type=script&lang=js&"
import style0 from "./SCodePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports